import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';
import {IGetWorldpayDDCOptions, IGetWorldpayResponse, endpointsMap} from './ICustomShopperWorldpay';

/**
 * Represents CustomShopperWorldpay class
 */
class CustomShopperWorldpay extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Fetches the Worldpay DDC (Device Data Collection) information.
	 *
	 * @param {IGetWorldpayDDCOptions} [fetchOptions={}] - Options for fetching the Worldpay DDC data.
	 * Defaults to an empty object if not provided.
	 * @param {boolean} [throwOnError] - Determines whether to throw an error if no JWT is returned.
	 * @returns {Promise<IGetWorldpayResponse>} - A promise that resolves to the Worldpay response object.
	 * @throws {Error} If throwOnError is true and no JWT is returned in the response.
	 */
	public async getDDC(
		fetchOptions: IGetWorldpayDDCOptions = {},
		throwOnError?: boolean,
	): Promise<IGetWorldpayResponse> {
		const response: IGetWorldpayResponse = await this.callCustomEndpoint<IGetWorldpayResponse>(
			fetchOptions,
			endpointsMap.GET_DDC,
		);

		if (throwOnError && !response.JWT) {
			throw new Error('No JWT returned.');
		}

		return response;
	}
}

export default CustomShopperWorldpay;
